export const CREATORS = 'CREATORS';

export const allCreators = (data) => {
	console.log('creator data', data)
    return {
        type: CREATORS,
        creators: data
    }
};
